export default "__VITE_ASSET__BXjiDH6H__"